const activeButtonEquipStatusBtn = {
  true: 'Inactivar',
  false: 'Reactivar',
  label: ' Equipo'
};

export default activeButtonEquipStatusBtn;
